module.exports = __webpack_public_path__ + "static/media/masheed.ec8025a0.webp";